var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "64px",
    viewBox: "0 0 62 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tertiary-perceived-stress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,10.390143),translate(-0.489155,-0.509384)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.150000,1.000000),rotate(90.000000),scale(1.000000,6.430410),translate(-0.489155,-0.509384)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "22.8553185%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5797101,57.9710145 L32,57.9710145 L32,61.2173913 C32,62.2419195 31.1694558,63.0724638 30.1449275,63.0724638 L26.4347826,63.0724638 C25.4102544,63.0724638 24.5797101,62.2419195 24.5797101,61.2173913 L24.5797101,57.9710145 L24.5797101,57.9710145 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "47.5280762%",
    x2: "50%",
    y2: "80.4794312%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.75,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.8695652,44.5217391 L35.7101449,44.5217391 L35.7101449,54.7246377 C35.7101449,57.2859583 33.6337843,59.3623188 31.0724638,59.3623188 L25.5072464,59.3623188 C22.9459258,59.3623188 20.8695652,57.2859583 20.8695652,54.7246377 L20.8695652,44.5217391 L20.8695652,44.5217391 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.75,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-9",
    cx: 27.826087,
    cy: 27.826087,
    r: 25.9710145
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.9%",
    y: "-2.9%",
    width: "105.8%",
    height: "105.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-11",
    cx: 27.826087,
    cy: 27.826087,
    r: 22.7246377
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.3%",
    y: "-3.3%",
    width: "106.6%",
    height: "106.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-14",
    cx: 27.826087,
    cy: 27.826087,
    r: 22.7246377
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.9%",
    y: "-3.9%",
    width: "107.7%",
    height: "107.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-16",
    cx: 27.826087,
    cy: 27.826087,
    r: 24.5797101
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.6%",
    y: "-3.6%",
    width: "107.1%",
    height: "107.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "13.5723305%",
    x2: "0%",
    y2: "86.4276695%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.88932332,-0.758236706 L5.57815328,21.9687106 C5.53637602,22.6928498 6.08953968,23.3137478 6.8136789,23.3555251 C6.83886753,23.3569783 6.8640928,23.3577053 6.88932332,23.3577053 C7.61466665,23.3577053 8.2026736,22.7696984 8.2026736,22.044355 C8.2026736,22.0191245 8.20194655,21.9938993 8.20049336,21.9687106 L6.88932332,-0.758236706 L6.88932332,-0.758236706 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.1%",
    y: "-4.1%",
    width: "238.1%",
    height: "115.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-20"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Employee-Wellbeing-Tracker",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wellbeing-Tracker-1st-Use-LG-03.0.0",
    transform: "translate(-887.000000, -2178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hrs-Per-Week",
    transform: "translate(854.000000, 2146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-perceived-stress",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-1)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 32,
    cy: 2,
    rx: 32,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-2)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 32,
    cy: 1.5,
    rx: 16,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-3)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 31.6666667,
    cy: 62,
    rx: 6.66666667,
    ry: 1
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pressure",
    strokeWidth: 1,
    transform: "translate(3.463768, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "url(#linearGradient-8)",
    strokeWidth: 0.509235578,
    strokeLinejoin: "square",
    cx: 27.826087,
    cy: 27.826087,
    r: 25.7163967
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "url(#linearGradient-13)",
    strokeWidth: 0.507936508,
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.5,
    transform: "translate(27.826087, 27.826087) rotate(-90.000000) translate(-27.826087, -27.826087) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "url(#linearGradient-13)",
    strokeWidth: 0.507936508,
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.826087,47.3043478 C38.5836334,47.3043478 47.3043478,38.5836334 47.3043478,27.826087 C47.3043478,17.0685405 38.5836334,8.34782609 27.826087,8.34782609 C17.0685405,8.34782609 8.34782609,17.0685405 8.34782609,27.826087",
    id: "Oval",
    stroke: "#575756",
    strokeWidth: 0.507936508,
    strokeLinecap: "round",
    strokeDasharray: "7.126192607576884,9.501590789310516",
    transform: "translate(27.826087, 27.826087) rotate(-45.000000) translate(-27.826087, -27.826087) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.826087,10.6666667 C37.3029731,10.6666667 44.9855072,18.3492008 44.9855072,27.826087 C44.9855072,32.56453 43.0648737,36.8543851 39.9596294,39.9596294 L27.826087,27.826087 L15.6925445,39.9596294 C12.5873002,36.8543851 10.6666667,32.56453 10.6666667,27.826087 C10.6666667,18.3492008 18.3492008,10.6666667 27.826087,10.6666667 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9596294,15.6924986 C43.0648737,18.7977429 44.9855072,23.0875979 44.9855072,27.826041 C44.9855072,32.5644841 43.0648737,36.8543392 39.9596294,39.9595835 L27.826087,27.826087 Z",
    id: "Combined-Shape",
    fill: "#FF520B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#575756",
    x: 21.7971014,
    y: 42.2028986,
    width: 12.057971,
    height: 1.39130435,
    rx: 0.695652174
  }), /*#__PURE__*/React.createElement("g", {
    id: "needle",
    transform: "translate(28.849897, 24.262656) rotate(43.000000) translate(-28.849897, -24.262656) translate(21.849897, 12.762656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-4",
    transform: "translate(6.889323, 11.299734) rotate(-28.000000) translate(-6.889323, -11.299734) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-20)",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-19"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#575756",
    cx: 27.826087,
    cy: 27.826087,
    r: 2.7826087
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D9D9D9",
    cx: 27.826087,
    cy: 27.826087,
    r: 1.39130435
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 27.826087,
    cy: 27.826087,
    r: 1
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialIcon);
export default __webpack_public_path__ + "static/media/dial-icon.07c6ccf4d18ee1066dff801b42790be1.svg";
export { ForwardRef as ReactComponent };